import { EvaluatorScoreEntry } from '../../table/types';

/**
 * The mark a candidate was awarded for a question, picked like the candidate report table does
 * (TableFeature getEvaluatorScore, student branch): the latest round's grader score, else the
 * question's own (automatic) score. Undefined when neither exists.
 */
export const getAwardedScore = (evaluatorScores?: EvaluatorScoreEntry[], score?: number): number | undefined => {
    const latest = evaluatorScores?.reduce(
        (latestScore: EvaluatorScoreEntry | undefined, currentScore: EvaluatorScoreEntry) => (
            !latestScore || currentScore.evaluationRound > latestScore.evaluationRound ? currentScore : latestScore
        ),
        undefined,
    );
    return latest?.evaluatorScore ?? score;
};
